<div class="-breadcrumb-container">
  <span>DevHub</span>
  <icon icon="singlearrow-right"></icon>
  <span>Breadcrumb Example</span>
  <icon icon="singlearrow-right"></icon>
  <span>Payrix</span>
</div>